import { render, staticRenderFns } from "./audio-hero-image.vue?vue&type=template&id=4d90c8a7&scoped=true&"
import script from "./audio-hero-image.vue?vue&type=script&lang=js&"
export * from "./audio-hero-image.vue?vue&type=script&lang=js&"
import style0 from "./audio-hero-image.vue?vue&type=style&index=0&id=4d90c8a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d90c8a7",
  null
  
)

export default component.exports